var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-dialog'),_vm._v(" "),(_vm.type=='desktop')?_c('div',[_c('ShoppingDesktop',{attrs:{"items":_vm.items,"total_items":_vm.total_items,"total_amount":_vm.total_amount}})],1):_c('div',[_c('ShoppingMobile',{attrs:{"items":_vm.items,"total_items":_vm.total_items,"total_amount":_vm.total_amount}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52d0c9df","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shopping.vue
// module id = null
// module chunks = 